// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__XYPAf","content":"Consent_content__15Ge7","footer":"Consent_footer__31m9k"};